import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "card h-100 text-center bg-transparent border-dark" }
const _hoisted_2 = {
  class: "card-header d-flex flex-row flex-wrap align-items-center justify-content-center p-1 bg-dark text-white",
  style: {"min-height":"3rem"}
}
const _hoisted_3 = { class: "my-0 mx-4 d-none d-md-block" }
const _hoisted_4 = { class: "form-group d-inline-flex m-0 mx-4" }
const _hoisted_5 = {
  tabindex: "-1",
  class: "btn-group-toggle btn-group btn-group-sm bv-no-focus-ring"
}
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "h-100 d-flex flex-column border border-left border-right" }
const _hoisted_9 = ["show"]
const _hoisted_10 = ["width", "height"]
const _hoisted_11 = { class: "card-footer text bg-dark text-white" }
const _hoisted_12 = { class: "text-nowrap" }
const _hoisted_13 = { class: "badge d-inline-flex text-truncate mw-100 badge-secondary" }
const _hoisted_14 = { class: "m-3" }
const _hoisted_15 = { class: "badge badge-secondary" }
const _hoisted_16 = { class: "m-3" }
const _hoisted_17 = { class: "badge badge-secondary" }
const _hoisted_18 = { class: "m-3" }
const _hoisted_19 = { class: "badge badge-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.t('previewcanvas.header.text')), 1),
      _createElementVNode("fieldset", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (value, key) => {
              return (_openBlock(), _createElementBlock("label", { key: key }, [
                _withDirectives(_createElementVNode("input", {
                  id: key,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
                  type: "radio",
                  name: "radios-btn-default",
                  class: "btn-check",
                  value: key
                }, null, 8, _hoisted_6), [
                  [_vModelRadio, _ctx.selected]
                ]),
                _createElementVNode("label", {
                  class: "btn btn-secondary btn-sm",
                  for: key
                }, _toDisplayString(value), 9, _hoisted_7)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "card-body h-100",
      onDblclick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fullSizePreview = !_ctx.fullSizePreview))
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "preview-layer b-overlay-wrap position-relative d-flex flex-column flex-grow-1 align-items-center justify-content-between overflow-auto p-1",
          show: _ctx.showProcessIndicator
        }, [
          _createElementVNode("canvas", {
            id: "canvas",
            ref: "canvas",
            class: _normalizeClass(["mx-auto", {
              'mw-100': !_ctx.fullSizePreview,
              'mh-100': !_ctx.fullSizePreview,
            }]),
            width: _ctx.width,
            height: _ctx.height,
            rel: "canvas"
          }, null, 10, _hoisted_10)
        ], 8, _hoisted_9)
      ])
    ], 32),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _createElementVNode("p", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.name), 1)
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("span", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.t('previewcanvas.dimensions.label')), 1),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.width) + "x" + _toDisplayString(_ctx.height), 1)
        ]),
        _withDirectives(_createElementVNode("span", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.t('previewcanvas.size.label')), 1),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.sizeToMb) + " " + _toDisplayString(_ctx.t('previewcanvas.size.value')), 1)
        ], 512), [
          [_vShow, _ctx.selected !== 'preliminary-preview']
        ]),
        _withDirectives(_createElementVNode("span", _hoisted_18, [
          _createTextVNode(_toDisplayString(_ctx.t('previewcanvas.type.label')), 1),
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.type), 1)
        ], 512), [
          [_vShow, _ctx.selected !== 'preliminary-preview']
        ])
      ])
    ], 512), [
      [_vShow, _ctx.show]
    ])
  ]))
}